<head>
  <meta charset="utf-8">
  <meta content="width=device-width, initial-scale=1.0" name="viewport">

  <title>SAION - Tecnología gubernamental</title>
  <meta content="" name="description">
  <meta content="" name="keywords">

  <!-- Favicons -->
  <link href="/assets/img/favicon.png" rel="icon">
  <link href="/assets/img/apple-touch-icon.png" rel="apple-touch-icon">

  <!-- Google Fonts -->
  <link href="https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Roboto:300,300i,400,400i,500,500i,600,600i,700,700i|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i" rel="stylesheet">

  <!-- Vendor CSS Files -->
  <link href="/assets/vendor/animate.css/animate.min.css" rel="stylesheet">
  <link href="/assets/vendor/aos/aos.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap/css/bootstrap.min.css" rel="stylesheet">
  <link href="/assets/vendor/bootstrap-icons/bootstrap-icons.css" rel="stylesheet">
  <link href="/assets/vendor/boxicons/css/boxicons.min.css" rel="stylesheet">
  <link href="/assets/vendor/glightbox/css/glightbox.min.css" rel="stylesheet">
  <link href="/assets/vendor/remixicon/remixicon.css" rel="stylesheet">
  <link href="/assets/vendor/swiper/swiper-bundle.min.css" rel="stylesheet">

  <!-- Template Main CSS File -->
  <link href="/assets/css/style.css" rel="stylesheet">

  <!-- =======================================================
  * Template Name: Company - v4.7.0
  * Template URL: https://bootstrapmade.com/company-free-html-bootstrap-template/
  * Author: BootstrapMade.com
  * License: https://bootstrapmade.com/license/
  ======================================================== -->
</head>



<footer id="footer">

  <div class="footer-top">
    <div class="container">
      <div class="row">

        <div class="col-lg-3 col-md-6 footer-links">
          <img src="assets/img/logo-footer.PNG" alt="">

         </div>



        <div class="col-lg-3 col-md-6 footer-contact">
          <h3>CONTACTO</h3>
          <p>
            Calle V. Carranza # 1 <br> Col. Centro, C.P. 48900 <br>
            Autlán,Jalisco<br>
            México <br><br>
            <strong>Télefono:</strong> +52 317 382 5100<br>
            <strong>Correo:</strong> contacto@autlan.gob.mx<br>

          </p>
        </div>

        <div class="col-lg-2 col-md-6 footer-links">
          <h4>Mapa del Sitio</h4>
          <ul>
            <li><i class="bx bx-chevron-right"></i> <a href="admin/indice">Inicio</a></li>
            <li><i class="bx bx-chevron-right"></i> <a href="admin/directorio">Directorio</a></li>
            <li><i class="bx bx-chevron-right"></i> <a href="https://transparencia.autlan.gob.mx/admin/indice">Transparencia</a></li>
            <li><i class="bx bx-chevron-right"></i> <a href="admin/tramites-y-servicios">Tramites y Servicios</a></li>
            <li><i class="bx bx-chevron-right"></i> <a href="https://transparencia.autlan.gob.mx/admin/avisos-de-privacidad">Aviso de Privacidad</a></li>


          </ul>
        </div>

        <div class="col-lg-3 col-md-6 footer-links">
          <h4 >Redes Sociales</h4>
          <ul>
            <a href="https://twitter.com/GobiernoAutlan" target="_blank" class="twitter"><i class="bu bi-twitter"></i></a>
      <a href="https://www.facebook.com/GobiernodeAutlan" target="_blank" class="facebook"><i class="bu bi-facebook"></i></a>
      <a href="https://www.youtube.com/channel/UC
      CukDOtB-8M-VWL7gJZK01Q" target="_blank" class="youtube"><i class="bu bi-youtube"></i></a>


          </ul>
          <div *ngIf="this.token === true">
            <button style="border: 0px; background-color: rgb(255, 255, 255);border-radius: 1vh;"> <a href="admin/pie-de-pagina/actualizar"
                style="color: aliceblue;"><img src="https://img.icons8.com/material-outlined/24/null/edit-image.png" /> </a>
            </button>
          </div>
        </div>


      </div>
    </div>
  </div>

  <div class="container d-md-flex py-4">

    <div class="me-md-auto text-center text-md-start">
      <div class="copyright">
        &copy; A U T L Á N

       <strong><span>  GOBIERNO MUNICIPAL 2021 - 2024</span></strong>   © Copyright autlan.gob.mx
      </div>

    </div>

  </div>
</footer><!-- End Footer -->
